import store from "@/store";
import { getModule, Module, Mutation, VuexModule } from "vuex-module-decorators";

export interface IMenuState {
  menuListMap: { [key: string]: any };
  menuItemKey: string;
}

@Module({ dynamic: true, store, name: "Menu" })
class Menu extends VuexModule implements IMenuState {
  public menuListMap = {};
  public menuItemKey = "";

  @Mutation
  SET_MENU_LIST_MAP(map: { [key: string]: any }) {
    this.menuListMap = map;
  }

  @Mutation
  SET_MENU_ITEM_KEY(key: string) {
    this.menuItemKey = key;
  }
}
export const MenuModule = getModule(Menu);
